import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { DeviceDetectorService } from "ngx-device-detector";
import {
  claimEscape,
  isDismissEscape,
  isEscapeClaimed,
} from "@bitwarden/web-vault/app/shared/utils/escape-claim";
import { MappedStatementRow } from "@bitwarden/web-vault/app/shared/utils/file-upload/statement-mapping.util";
import { closeAfterExitAnimation } from "@bitwarden/web-vault/app/shared/utils/exit-animation.util";

@Component({
  selector: "app-file-full-preview",
  templateUrl: "./file-full-preview.component.html",
})
export class FileFullPreviewComponent {
  @Input() file: File;
  @Input() fileName = "";
  /** Mapped statement rows; when present the preview shows the mapped table instead of the raw file. */
  @Input() mappedRows: MappedStatementRow[] = [];
  @Output() closed = new EventEmitter<void>();

  /** Mobile renders a full-screen sheet; desktop renders a draggable, resizable window. */
  protected readonly isMobile: boolean = inject(DeviceDetectorService).isMobile();

  @ViewChild("mobileSheet") private mobileSheet?: ElementRef<HTMLElement>;

  /** The mobile sheet slides out first (see .mobile-slide-in-page); the desktop window closes at once. */
  close(): void {
    closeAfterExitAnimation(this.mobileSheet?.nativeElement, () => this.closed.emit());
  }

  // The desktop window isn't modal (focus can be anywhere), so it listens globally - but only takes
  // an Escape nothing else used (a dialog or dropdown that closed on it). claimEscape: when the
  // window sits over a dialog, the Escape is used up here and must not also close the dialog. The
  // mobile sheet gets Escape from appModalOverlay.
  @HostListener("window:keydown.escape", ["$event"])
  onEscapeKey(event: KeyboardEvent): void {
    if (this.isMobile || !isDismissEscape(event) || isEscapeClaimed(event)) {
      return;
    }
    claimEscape(event);
    this.close();
  }
}
